import { Action, Module, VuexModule, Mutation } from 'vuex-module-decorators';
import { DashboardDTO } from '@/data/dto/dashboards.dto';
import MOMABffService from '@/services/moma-bff.service';

const service = new MOMABffService();

@Module
export default class DashboardModule extends VuexModule {
  isDashboardRegistered = false;

  @Action
  async getAllDashboards(
    params?: Record<string, any>
  ): Promise<DashboardDTO[]> {
    const { dashboards } = await service.getAllDashboards();
    let filtered = dashboards;
    if (params?.active !== undefined) {
      filtered = dashboards.filter((d) => d.active === params.active);
    }
    filtered.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
    return filtered;
  }

  @Action
  async createDashboard(payload: Partial<DashboardDTO>): Promise<void> {
    await service.createDashboard(payload);
  }

  @Action
  async updateDashboard(payload: {
    id: number;
    data: Partial<DashboardDTO>;
  }): Promise<void> {
    await service.updateDashboard(payload.id, payload.data);
  }

  @Action
  async deleteDashboard(id: number): Promise<void> {
    await service.deleteDashboard(id);
  }

  @Action
  async changeDashboardStatus(payload: {
    id: number;
    active: boolean;
  }): Promise<void> {
    await service.changeDashboardStatus(payload.id, payload.active);
  }

  @Action
  async reorderDashboards(sortedIdList: number[]): Promise<void> {
    await service.reorderDashboards(sortedIdList);
  }

  @Action
  async setDashboardRegistered(value: boolean): Promise<void> {
    this.context.commit('setDashboardRegisteredState', value);
  }

  @Mutation
  setDashboardRegisteredState(value: boolean): void {
    this.isDashboardRegistered = value;
  }
}
